var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","d":"M5 13l4 4L19 7"}));
}

Check.defaultProps = {"fill":"none","viewBox":"0 0 24 24","stroke":"currentColor"};

module.exports = Check;

Check.default = Check;
